import videobg from '../videos/vid38.mp4';
import { useNavigate } from "../router";
import scroll from "../utils/scroll";

export const Header = (props) => {
  const navigate = useNavigate();

  const handleExploreServices = (e) => {
    e.preventDefault();
    navigate("/");
    setTimeout(() => {
      const target = document.getElementById("services");
      if (target) {
        scroll.animateScroll(target, { offset: 58 });
      } else {
        scroll.animateScroll(0);
      }
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, "/");
      }
    }, 20);
  };

  const stats = [
    { label: 'Availability', value: '99.99%' },
    { label: 'Latency', value: '<120ms' },
    { label: 'Regions', value: '22' },
    { label: 'Assets Secured', value: '1.4M+' },
  ];

  return (
    <header id='header'>
      <div className='intro'>
        <video autoPlay loop muted playsInline id='video'>
          <source src={videobg} type='video/mp4' />
        </video>
        <div className='overlay intro-glass'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-10 col-md-offset-1 intro-text hero-content'>
                <p className='eyebrow'>Cloud Security · Cloud Automation </p>
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1>
                <p className='lead'>
                  {props.data ? props.data.paragraph : 'Loading'}
                </p>
                <div className='cta-row'>
                  <a href='/' className='btn btn-custom btn-lg page-scroll' onClick={handleExploreServices}>
                    Explore Our Services
                  </a>
                  <span className='cta-label'>Check Out Our Latest Product →</span>
                  <a
                    href='https://www.cloudidentitymesh.com/'
                    className='btn btn-ghost btn-lg'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Cloud Identity Mesh
                  </a>
                </div>
                <div className='stat-bar'>
                  {stats.map((stat) => (
                    <div key={stat.label} className='stat'>
                      <span className='dot' />
                      <div className='stat-label'>{stat.label}</div>
                      <div className='stat-value'>{stat.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
